import {
  fetchClient
} from "./chunk-EIW2CIXT.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/blog/list/listing.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getBlogArticles = (_0) => __async(void 0, [_0], function* ({ lang }) {
  try {
    const locale = getLocaleOnly(lang);
    const cat = locale === "en" ? "57" : "58";
    const data = yield fetchClient({
      url: `/blog/wp-json/wp/v2/posts?lang=${locale}&categories=${cat}&&orderby=date&order=desc`
    });
    return data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getBlogException"
    });
  }
});

export {
  getBlogArticles
};
//# sourceMappingURL=chunk-VFRBTVYA.mjs.map